import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Competitions from '../views/Competitions/Competitions'
import CompetitionDetails from '../views/Competitions/components/CompetitionDetails'
import CompetitionStepOne from '../views/Competitions/components/CompetitionStepOne'
import CompetitionStepThree from '../views/Competitions/components/CompetitionStepThree'
import CompetitionStepTwo from '../views/Competitions/components/CompetitionStepTwo'
import PassThrough from '../views/Competitions/components/PassThrough'
import ComplexFilterList from '../views/Complex-filter/ComplexFilterList'
import CreateComplexFilter from '../views/Complex-filter/CreateComplexFilter'
import Contents from '../views/Contents/Contents'
import CreateNews from '../views/News/CreateNews'
import ListNews from '../views/News/ListNews'
import PrivateHome from '../views/PrivateHome.vue'
import CreateProgram from '../views/Program/CreateProgram'
import Program from '../views/Program/Program'
import CreateService from '../views/Service/CreateService'
import Service from '../views/Service/Service'
// import Users from '../views/Users.vue'
import { competitionSubTypes } from '../constants/competitionSubTypes'
import AccessManagement from '../views/AccessManagement'
import { isKauLogin, permissionGuard } from './guards'

Vue.use(VueRouter)

const privateRoutes = [
  {
    path: '/home',
    name: 'PrivateHome',
    component: PrivateHome
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/profile-edit',
    name: 'ProfileEdit',
    component: () => import('../views/ProfileEdit.vue')
  },
  {
    path: '/favourites',
    name: 'Favourites',
    component: () => import('../views/Favourites/Favourites.vue')
  },
  {
    path: '/add-company-private',
    name: 'PrivateAddCompany',
    component: () => import('../views/PrivateAddCompany.vue')
  },
  {
    path: '/add-sole-proprietorship-private',
    name: 'PrivateAddSoleProprietorship',
    component: () => import('../views/PrivateAddSoleProprietorship.vue')
  },
  {
    path: '/company-offers-private',
    name: 'PrivateCompanyOffers',
    component: () => import('../views/PrivateCompanyOffers.vue')
  },
  //TODO:
  {
    path: '/sole-proprietorship-offers-private',
    name: 'PrivateSoleProprietorshipOffers',
    component: () => import('../views/PrivateSoleProprietorshipOffers.vue')
  },

  {
    path: '/sole-proprietorship-offers-private',
    name: 'PrivateSoleProprietorshipOffers',
    component: () => import('../views/PrivateSoleProprietorshipOffers.vue')
  },

  {
    path: '/company-offerlist',
    name: 'OfferList',
    component: () => import('../views/OfferList.vue')
  },
  // TODO
  {
    path: '/sole-proprietorship-offerlist',
    name: 'SoleProprietorshipOfferList',
    component: () => import('../views/SoleProprietorshipOfferList.vue')
  },
  {
    path: '/kkv-result',
    name: 'Result',
    component: () => import('../views/Result')
  },
  {
    path: '/test-kau',
    name: 'AvailableForKauLoggedInUser',
    component: () => import('../views/AvailableForKauLoggedInUser.vue'),
    beforeEnter: isKauLogin
  }
]

const privateMetaFields = {
  private: true
}

const privateRoutesWithMeta = privateRoutes.map(route => {
  return { ...route, meta: privateMetaFields }
})

const publicRoutes = [
  {
    path: '/',
    name: 'PublicHome',
    component: () => import('../views/PublicHome.vue'),
    meta: {
      title: 'Vali.hu'
    }
  },
  {
    path: '/fund-map',
    name: 'FundMap',
    component: () => import('../views/FundMap/index.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    }
  },
  {
    path: '/fund-map/company-details',
    name: 'FundMapCompanyDetails',
    component: () => import('../views/FundMap/FundMapCompanyDetails.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    }
  },
  {
    path: '/fund-map/create-company',
    name: 'FundMapCreateImaginaryCompany',
    component: () => import('../views/FundMap/CreateImaginaryCompany.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    },
    children: []
  },
  {
    path: '/fund-map/imaginary-company-details',
    name: 'FundMapImaginaryCompanyDetails',
    component: () => import('../views/FundMap/CreateImaginaryCompanyDetails.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    },
    children: [],
    props: true
  },
  {
    path: '/fund-map/fund/:id',
    name: 'FundMapCompetitionDetails',
    component: () => import('../views/FundMap/FundMapCompetitionDetails.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    }
  },
  {
    path: '/fund-map/search',
    name: 'FundMapSearch',
    component: () => import('../views/FundMap/FundMapSearch.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    },
    children: []
  },
  {
    path: '/fund-map/search/category-map',
    name: 'FundMapSearch',
    component: () => import('../views/FundMap/FundMapCategoryMap.vue'),
    meta: {
      title: 'Vali.hu | Forrástérkép'
    },
    children: []
  },
  {
    path: '/business-development-services',
    name: 'BusinessDevelopmentServices',
    component: () => import('../views/BusinessDevelopmentServices.vue')
  },
  {
    path: '/courses',
    name: 'PublicCourses',
    component: () => import('../views/PublicCourses.vue')
  },
  {
    path: '/szechenyi-programiroda',
    name: 'SzechenyiProgramiroda',
    component: () => import('../views/SzechenyiProgramirodaInformation.vue')
  },
  {
    path: '/egypluszegy-program',
    name: 'egypluszegy',
    component: () => import('../views/1+1.vue')
  },
  {
    path: '/demjansandorprogram',
    name: 'demjansandorprogram',
    component: () => import('../views/demjansandor.vue')
  },
  {
    path: '/ds-tanacsadasi-voucher-program',
    name: 'DemjanSandorTanacsadasiVoucherProgram',
    component: () => import('../views/dsTanacsadasiVoucherProgram.vue')
  },
  {
    path: '/ESG',
    name: 'ESG',
    component: () => import('../views/ESG.vue')
  },
  {
    path: '/ESG/Akkreditáció',
    name: 'Akkreditáció',
    component: () => import('../views/ESGAccreditation.vue')
  },
  {
    path: '/ESG/Intezmenyek',
    name: 'Intézmények',
    component: () => import('../views/ESGInstitutions.vue')
  },
  {
    path: '/ESG/Kezikonyvek-utmutatok',
    name: 'Kezikonyvek-utmutatok',
    component: () => import('../views/ESGHandbooksInstructions.vue')
  },
  {
    path: '/ESG/Vallalkozasok',
    name: 'Vallalkozasok',
    component: () => import('../views/ESGEnterprises.vue')
  },
  {
    path: '/ESG/Treningek',
    name: 'Treningek',
    component: () => import('../views/ESGTrainings.vue')
  },
  // {
  //   path: '/ESG/Forms',
  //   name: 'kepzesi-urlap',
  //   component: () => import('../views/ESGForms.vue')
  // },
  {
    path: '/energiatamogatas',
    name: 'EnergySupportProgram',
    component: () => import('../views/EnergySupportProgram_old.vue')
  },
  /* {
    path: '/energiatamogatas_new',
    name: 'EnergySupportProgram',
    component: () => import('../views/EnergySupportProgram.vue')
  }, */
  {
    path: '/energiatamogatas/feldolgozoipar',
    name: 'EnergySupportManufacturing',
    component: () => import('../views/EnergySupportManufacturing.vue')
  },
  {
    path: '/energiatamogatas/szallas',
    name: 'EnergySupportCatering',
    component: () => import('../views/EnergySupportCatering.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/contents',
    component: PassThrough,
    beforeEnter: permissionGuard,
    children: [
      {
        path: '',
        name: 'Contents',
        component: Contents,
        beforeEnter: permissionGuard
      },
      {
        path: 'services',
        component: PassThrough,
        beforeEnter: permissionGuard,
        children: [
          {
            path: '',
            name: 'Services',
            component: Service,
            beforeEnter: permissionGuard
          },
          {
            path: 'create',
            name: 'CreateService',
            component: CreateService,
            beforeEnter: permissionGuard
          },
          { path: 'create', name: 'EditProgram', component: CreateProgram, alias: 'edit' }
        ]
      },
      {
        path: 'programs',
        component: PassThrough,
        beforeEnter: permissionGuard,
        children: [
          {
            path: '',
            name: 'Programs',
            component: Program,
            beforeEnter: permissionGuard
          },
          {
            path: 'create',
            name: 'CreateProgram',
            component: CreateProgram,
            beforeEnter: permissionGuard
          },
          { path: 'create', name: 'EditProgram', component: CreateProgram, alias: 'edit' }
        ]
      },
      {
        path: 'news',
        component: PassThrough,
        beforeEnter: permissionGuard,
        children: [
          {
            path: '',
            name: 'ListNews',
            component: ListNews,
            beforeEnter: permissionGuard
          },
          {
            path: 'create',
            name: 'CreateNews',
            component: CreateNews,
            beforeEnter: permissionGuard
          },
          { path: 'create', name: 'EditNews', component: CreateNews, alias: 'edit' }
        ]
      },
      {
        path: 'access-management',
        component: PassThrough,
        beforeEnter: permissionGuard,
        children: [
          {
            path: '',
            name: 'AccessManagement',
            component: AccessManagement,
            beforeEnter: permissionGuard
          }
        ]
      }
    ]
  },
  {
    path: '/fund-categories',
    name: 'FundCategories',
    beforeEnter: permissionGuard,
    component: () => import('../views/FundMap/cms/index.vue')
  },
  {
    path: '/fund-categories/add-main-category',
    name: 'AddMainCategory',
    beforeEnter: permissionGuard,
    component: () => import('../views/FundMap/cms/AddMainCategory.vue')
  },
  {
    path: '/fund-categories/edit-main-category',
    name: 'EditMainCategory',
    beforeEnter: permissionGuard,
    component: () => import('../views/FundMap/cms/EditMainCategory.vue')
  },
  {
    path: '/create-fund',
    name: 'CreateFund',
    beforeEnter: permissionGuard,
    component: () => import('../views/FundCreation/index.vue')
  },
  {
    path: '/system-email/home',
    name: 'SystemEmail',
    beforeEnter: permissionGuard,
    component: () => import('../views/SystemEmail/SystemEmailHome.vue')
  },
  {
    path: '/system-email/send-email',
    name: 'SystemEmail',
    beforeEnter: permissionGuard,
    component: () => import('../views/SystemEmail/SystemEmailSend.vue')
  },
  {
    path: '/system-email/create-group',
    name: 'SystemEmail',
    beforeEnter: permissionGuard,
    component: () => import('../views/SystemEmail/SystemEmailCreateGroup.vue')
  },
  {
    path: '/competitions',
    component: PassThrough,
    beforeEnter: permissionGuard,
    children: [
      {
        path: '',
        name: 'Competitions',
        component: Competitions
      },
      {
        path: 'details',
        name: 'CompetitionDetails',
        component: CompetitionDetails
      },
      {
        path: 'competition/1',
        name: 'CompetitionStepOne',
        component: CompetitionStepOne
      },
      {
        path: 'competition/2',
        name: 'CompetitionStepTwo',
        component: CompetitionStepTwo
      },
      {
        path: 'competition/3',
        name: 'CompetitionStepThree',
        component: CompetitionStepThree
      },
      {
        path: 'complex-filter',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'ComplexFilter',
            component: ComplexFilterList
          },
          { path: 'create', name: 'EditComplexFilter', component: CreateComplexFilter, alias: 'edit' }
        ]
      },
      {
        path: 'create-complex-filter',
        name: 'CreateComplexFilter',
        component: CreateComplexFilter
      }
    ]
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forgot',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('../views/PasswordReset.vue')
  },
  {
    path: '/palyazati-utmutato',
    name: 'CompetitionGueide',
    component: () => import('../views/CompetitionGuide/CompetitionGuide.vue')
  },
  {
    path: '/confirm-registration',
    name: 'ConfirmRegister',
    component: () => import('../views/ConfirmRegister.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../views/Impressum.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfUse',
    component: () => import('../views/TermsOfUse.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/company-details',
    name: 'CompanyDetails',
    component: () => import('../views/CompanyDetails.vue'),
    props: true
  },
  {
    path: '/sole-proprietorship-details',
    name: 'SoleProprietorshipDetails',
    component: () => import('../views/SoleProprietorshipDetails.vue'),
    props: true
  },
  {
    path: '/company-offers',
    name: 'PublicCompanyOffers',
    component: () => import('../views/PublicCompanyOffers.vue')
  },
  {
    path: '/sole-proprietorship-offers',
    name: 'PublicSoleProprietorshipOffers',
    component: () => import('../views/PublicSoleProprietorshipOffers.vue')
  },
  {
    path: '/sole-proprietorship-more-details',
    name: 'PublicSoleProprietorshipMoreResults',
    component: () => import('../views/SoleProprietorshipMoreResults.vue')
  },
  {
    path: '/session-expired',
    name: 'SessionExpired',
    component: () => import('../views/SessionExpired.vue')
  },
  /*{
    path: '/programs/ginop_plusz-2.1.1-21',
    name: 'GinopPlusz-2.1.1-21',
    component: () => import('../views/Programs/GinopPlusz-2.1.1-21.vue')
  },*/
  {
    path: '/programs/ginop_plusz-1.2.1-21',
    name: 'GinopPlusz-1.2.1-21',
    component: () => import('../views/Programs/GinopPlusz-1.2.1-21.vue')
  },
  {
    path: '/programs/ginop_plusz-1.2.3-21',
    name: 'GinopPlusz-1.2.3-21',
    component: () => import('../views/Programs/GinopPlusz-1.2.3-21.vue')
  },
  {
    path: '/kkv-qualifier',
    name: 'KkvQualifier',
    component: () => import('../views/PublicKkv.vue')
  },
  {
    path: '/export-bank-biztosito',
    name: 'Exim',
    component: () => import('../views/Opportunities/PartnerOpportunity'),
    props: {
      title: 'Export Bank Biztosító',
      subType: competitionSubTypes.EXIM
    }
  },
  {
    path: '/szechenyi-kartya-hitelek',
    name: 'Szkp',
    component: () => import('../views/Opportunities/PartnerOpportunity'),
    props: {
      title: 'Széchenyi Kártya Hitelek',
      subType: competitionSubTypes.KAVOSZ
    }
  },
  {
    path: '/magyar-fejlesztesi-bank',
    name: 'Mfb',
    component: () => import('../views/Opportunities/PartnerOpportunity'),
    props: {
      title: 'Magyar Fejlesztési Bank',
      subType: competitionSubTypes.MFB
    }
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound.vue')
  },
  {
    path: '/page-not-allowed',
    component: () => import('../views/RequiredKauLogin.vue')
  },
  {
    path: '/news',
    name: 'NewsPage',
    component: () => import('../views/News/index.vue')
  },
  {
    path: '/news/details/:id',
    name: 'NewsDetails',
    component: () => import('../views/News/Details.vue')
  },
  {
    path: '/voucher-program',
    name: 'VoucherProgram',
    component: () => import('../views/VoucherProgram.vue')
  },
  {
    path: '/energetikai-voucher-program',
    name: 'EnergeticVoucherProgram',
    component: () => import('../views/EnergeticVoucherProgram.vue')
  },
  {
    path: '/knowledgebase',
    name: 'Knowledgebase',
    component: () => import('../views/Knowledgebase/index.vue')
  },
  {
    path: '/knowledgebase/:id',
    name: 'KnowledgebaseDefinitionDetails',
    component: () => import('../views/Knowledgebase/DefinitionDetails.vue')
  },
  {
    path: '/kau-login',
    name: 'KauLogin',
    component: () => import('../views/KauLogin.vue')
  },
  {
    path: '/*',
    redirect: '/page-not-found'
  }
]

const publicMetaFields = {
  public: true
}

const publicRoutesWithMeta = publicRoutes.map(route => {
  return { ...route, meta: publicMetaFields }
})

const routes = [...privateRoutesWithMeta, ...publicRoutesWithMeta]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  Vue.$gtag.event('user_journey', {
    event_category: 'user_interaction',
    from: from.path,
    to: to.path
  })
  const userProfile = store.state.userStore.user
  const isInitialStartup = store.state.loadingStore.isInitialStartup
  const isFromStartingIndexRoute = from.path === '/' && to.path == '/'
  if (isFromStartingIndexRoute && isInitialStartup) {
    store.commit('finishInitialStartup')
    if (userProfile) {
      next('/home')
    } else {
      next('/')
    }
  }

  const isPublicPage = to.matched.some(record => record.meta.public)
  if (isPublicPage) {
    if (!userProfile) {
      next()
    }
  }

  const isPrivatePage = to.matched.some(record => record.meta.private)
  if (isPrivatePage) {
    if (userProfile) {
      next()
    } else {
      next('/login')
    }
  }

  document.body.scrollTop = 0

  next()
})

export default router
